(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ControllerPaymentDeleteDialogController',ControllerPaymentDeleteDialogController);

    ControllerPaymentDeleteDialogController.$inject = ['$uibModalInstance','entity','ControllerPayment'];

    function ControllerPaymentDeleteDialogController($uibModalInstance, entity, ControllerPayment) {
        var vm = this;

        vm.cp = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ControllerPayment.delete({id:id}, function() {
                $uibModalInstance.close(true);
            });
        }
    }
})();
